import {HoistService, XH} from '@xh/hoist/core';
import {getDefaultOptions} from '../../core/ServiceUtils';
import {AiSpecAssistRequest, AiSpecAssistResponse} from '../data/AiSpecAssistTypes';

/**
 * Access to the backend AI spec assistant: turns a natural-language instruction plus a component's
 * current spec (GridSpec, ChartSpec) into ops. The ops are applied client-side, through the same
 * reducer as the manual configurator.
 */
export class AiSpecAssistService extends HoistService {
    /** False once the backend has reported that the endpoint does not exist. */
    isAvailable = true;

    async assistAsync(request: AiSpecAssistRequest): Promise<AiSpecAssistResponse> {
        try {
            return await XH.postJson({
                ...getDefaultOptions(),
                url: `${XH.getConf('svcApiUrl')}/ai/spec/assist`,
                body: request
            });
        } catch (e) {
            throw this.toError(e);
        }
    }

    private toError(e: any): Error {
        const status = e?.httpStatus;
        if (status === 404) {
            this.isAvailable = false;
            return new Error('The assistant is not available on the server yet.');
        }

        const details = parseJson(e?.serverDetails);
        if (status === 429) return new Error(details?.error ?? 'Daily AI usage limit reached. Please try again later.');
        if (status === 400) return new Error(details?.error ?? e?.serverDetails ?? 'The request was not valid.');
        return new Error(details?.detail ?? e?.message ?? 'The assistant failed.');
    }
}

function parseJson(s: any): any {
    if (typeof s !== 'string') return s ?? null;
    try {
        return JSON.parse(s);
    } catch {
        return null;
    }
}
